module.exports = __webpack_public_path__ + "images/world_map.svg";